<template>
    <ApiForm
        :url="urlFactory.makeAvailabilityStoreUrl()"
        method="POST"
        ref="apiFormRef"
    >
        <input
            type="hidden"
            :name="RequestBodyKeyEnum.App_Availability_TimeZone"
            :value="browserTimeZone"
        />
    </ApiForm>
    <Button
        @click="submit()"
        :loading="apiFormRef?.loading.valueOf()"
        iconName="plus"
        color="dark"
    >
        Create
    </Button>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Availability from '@/App/Availability/Entity/Availability'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        browserTimeZone: {
            type: String,
            default: null,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()
    }
    const urlFactory = new UrlFactory()
</script>
